import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Link as MuiLink, Typography } from '@mui/material';
import LegalLayout from './LegalLayout';

const CONTACT_EMAIL = 'bokonzibaoubab@gmail.com';
const WHATSAPP_NUMBER = (import.meta.env.VITE_WHATSAPP_NUMBER || '+242069230035').replace(/\D/g, '');

function SuppressionComptePage() {
  const whatsappMessage = encodeURIComponent(
    'Bonjour baoubab, je souhaite demander la suppression de mon compte.'
  );
  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${whatsappMessage}`;
  const mailtoUrl = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(
    'Demande de suppression de compte baoubab'
  )}&body=${encodeURIComponent(
    'Bonjour,\n\nJe souhaite supprimer mon compte baoubab.\n\nEmail du compte : \nNom : \n\nMerci.'
  )}`;

  return (
    <LegalLayout title="Suppression de compte">
      <Typography variant="body2" sx={{ color: '#888', mb: 2 }}>
        Dernière mise à jour : octobre 2026
      </Typography>

      <p>
        Vous pouvez demander la suppression de votre compte baoubab et des données
        associées à tout moment. Conformément à notre{' '}
        <MuiLink component={RouterLink} to="/confidentialite">
          politique de confidentialité
        </MuiLink>
        , nous traitons la demande dans un délai de <strong>30 jours</strong>.
      </p>

      <h2>Ce qui sera supprimé</h2>
      <ul>
        <li>votre compte (e-mail, nom, téléphone) ;</li>
        <li>les profils d&apos;enfants rattachés et leurs réponses aux questionnaires ;</li>
        <li>vos commandes et contenus débloqués, dans la mesure du possible ;</li>
        <li>vos jetons de session.</li>
      </ul>
      <p>
        Peuvent être conservées uniquement les données que la loi impose de garder
        (par exemple des pièces comptables liées à une commande payée), pour la durée légale.
      </p>

      <h2>Comment faire la demande</h2>
      <p>Choisissez l&apos;un des canaux suivants :</p>

      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, my: 3 }}>
        <Button
          variant="contained"
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            bgcolor: '#25D366',
            color: '#fff',
            fontWeight: 700,
            textTransform: 'none',
            px: 3,
            '&:hover': { bgcolor: '#1da851' },
          }}
        >
          Demander via WhatsApp
        </Button>
        <Button
          variant="contained"
          href={mailtoUrl}
          sx={{
            bgcolor: '#784e3c',
            color: '#fff !important',
            fontWeight: 700,
            textTransform: 'none',
            px: 3,
            '&:hover': { bgcolor: '#5f3e2f', color: '#fff !important' },
          }}
        >
          Demander par e-mail
        </Button>
      </Box>

      <p>
        Indiquez l&apos;adresse e-mail utilisée pour vous connecter à baoubab, afin que
        nous puissions identifier le compte. Vous pouvez aussi nous écrire via le{' '}
        <MuiLink component={RouterLink} to="/contact">formulaire de contact</MuiLink>.
      </p>

      <h2>Depuis l&apos;application</h2>
      <p>
        Dans le menu profil de l&apos;app, l&apos;action « Supprimer mon compte » ouvre
        également WhatsApp (ou un e-mail de secours) avec un message prérempli.
      </p>
    </LegalLayout>
  );
}

export default SuppressionComptePage;
